import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqPartMngStore', Object.keys(getters)),
	...mapState('pqPartMngStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqPartMngStore', Object.keys(actions)),
	...mapMutations('pqPartMngStore', Object.keys(mutations))
};
